module.exports = __webpack_public_path__ + "static/media/oops.4c9046dd.png";